import { safeDefine } from "../../registration/safe-define.js";
import { MenuItemIndicatorElement } from "../../ui/menu/item-indicator.js";
//#region src/define/ui/menu-item-indicator.ts
safeDefine(MenuItemIndicatorElement);
//#endregion

//# sourceMappingURL=menu-item-indicator.js.map